import { Api } from '../api';
import { products } from '../endpoints';
import type { Partner, Product, ProductWithCurrencies, ProductWithCurrenciesIndex } from './models';

const allowedCurrenciesIndex: { [key: string]: boolean } = {
  EUR: true,
  USD: true,
  CHF: true,
};

const maxCurrenciesIndex: { [key: string]: number } = {
  'b|1844': 2,
  'b|eyond': 1,
};

export class ProductApi extends Api {
  static getPartners = (signal?: AbortSignal) => this.get<Partner[]>(products.getPartners(), { signal });

  static getProducts = async (signal?: AbortSignal) => {
    const result = await this.get<Product[]>(products.getProducts(), { signal });
    return result?.length ? result.map((item) => ({ ...item, name: item.name.split(' ')[0] })) : result;
  };

  static getProductsWithCurrencies = async (signal?: AbortSignal): Promise<ProductWithCurrencies[]> => {
    const source = await this.getProducts(signal);

    const index = source
      ? source.reduce((acc, item): ProductWithCurrenciesIndex => {
          if (!item.simpleProductName) return acc;
          if (!allowedCurrenciesIndex[item.currency]) return acc;
          let accItem = acc[item.simpleProductName];
          if (!accItem) {
            accItem = {
              name: item.simpleProductName,
              currencies: {},
              maxCurrencies: maxCurrenciesIndex[item.simpleProductName],
            };
            acc[item.simpleProductName] = accItem;
          }
          accItem.currencies[item.currency] = true;
          return acc;
        }, {} as ProductWithCurrenciesIndex)
      : {};

    return Object.keys(index).map((key) => index[key]);
  };
}
